import React from 'react';
import '../../styles/onboardingFlow/onboardingComponents/onboardingFooter.scss';

const OnboardingFooter: React.FC = () => {
  return (
    <div className='onboardingFooter'>
      <p className='onboardingFooter__text'>© AdUp 2025</p>
    </div>
  );
};

export default OnboardingFooter;
